import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SessionData } from "../../interfaces/user.type";

export interface userState {
  data: SessionData | null;
}

const initialState: userState = {
  data: null,
};

export const sessionData = createSlice({
  name: "user",
  initialState,
  reducers: {
    setSessionData: (state, action: PayloadAction<SessionData | null>) => {
      state.data = action.payload;
    },
  },
});


export const { setSessionData } = sessionData.actions;

export default sessionData.reducer;